// angular
//     .module("HeroPRO")
//     .factory("AddProductsFactory", addProductsFactory);

import _ from 'lodash';

/* @ngInject */
export default function addProductsFactory($http, HPConfig, FRInformationFactory, $q) {
    let _docGenPromise = null;
    let _moduleData = null;
    const _modules = {
        dealTypePurchase: {
            visible: false,
        },
        dealTypeLease: {
            visible: false,
        },
        productTypes: {
            visible: false,
        },
        recentProducts: {
            visible: false,
        },
        filterProducts: {
            visible: false,
        },
        activeProduct: {
            visible: false,
        },
        selectedProducts: {
            visible: false,
        },
        caseCreation: {
            visible: false,
        },
        docGenProcessing: {
            visible: false,
        },
    };

    return {
        getModules,
        setVisibleModules,
        getAddedProductsCase,
        setDocGenPromise,
        getDocGenPromise,
        createAddProductCase,
        getModuleData,
        setModuleData,
        resetAddProductsFactory,
        openAddProductsWebsite
    };

    function getModules() {
        return _modules;
    }

    // visibleModules: array of stings, names of modules
    function setVisibleModules(visibleModules) {
        // Sets visible=false for all modules except for those passed in
        _.each(_modules, (module, moduleKey) => {
            const moduleFound = _.find(visibleModules, visibleModule => moduleKey === visibleModule);
            module.visible = (moduleFound !== undefined);
        });
    }

    // moduleData: json object, generic data to be shared between modules, outside of factories
    function setModuleData(key, value) {
        _moduleData = _moduleData || {};
        _moduleData[key] = value;
    }

    // this is for retrieving shared module data
    function getModuleData(key) {
        return _moduleData[key];
    }

    function getAddedProductsCase(fundingRequestId) {
        return $http.get(`${HPConfig.heroProApi}Case/AddProductCase`, {
            params: { fundingRequestId },
        });
    }

    function setDocGenPromise(newDocGenPromise) {
        _docGenPromise = newDocGenPromise;
    }

    function getDocGenPromise() {
        return _docGenPromise;
    }

    function createAddProductCase(data) {
        if (_moduleData.caseCreation && _.isObject(_moduleData.caseCreation)) {
            data.Notes = `${_moduleData.caseCreation.ResultStatus}, MessageSubject: ${_moduleData.caseCreation.Data.MessageSubject}, Message: ${_moduleData.caseCreation.Data.Message}`;
        }
        return $http.post(`${HPConfig.heroProApi}Case/AddProductCase`, data).then(response => response).catch(response => $q.reject(response.data));
    }

    function resetAddProductsFactory() {
        _moduleData = null;
    }

    function openAddProductsWebsite() {
        const appInfo = FRInformationFactory.getAppInfo();
        let link = HPConfig.addProductsWebLink;
        link += `/overview/${appInfo.FundingRequestId}/false`;
        link += `?token=${btoa(localStorage.getItem("ls.authorizationData"))}&returnUrl=${btoa(window.location.href)}`;
        window.open(link, "_self");
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/addProducts/addProductsFactory.js